<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="path-1-inside-1_9766_59789" fill="white">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.5997 4H4C2.34315 4 1 5.34314 1 7V15.3784C1 17.0352 2.34315 18.3784 4 18.3784H12.4717C12.4902 18.3784 12.5084 18.3835 12.5241 18.3932L18.8423 22.2866C19.2383 22.5307 19.7238 22.1491 19.5802 21.7066L18.5338 18.4827C18.5171 18.4312 18.5555 18.3784 18.6096 18.3784C19.9298 18.3784 21 17.3082 21 15.988V11.4003C20.2499 11.7837 19.4002 12 18.5 12C15.4624 12 13 9.53757 13 6.5C13 5.59978 13.2163 4.75007 13.5997 4Z"
      />
    </mask>
    <path
      d="M13.5997 4L14.4901 4.45517L15.234 3H13.5997V4ZM12.5241 18.3932L11.9995 19.2446H11.9995L12.5241 18.3932ZM18.8423 22.2866L19.3669 21.4353L18.8423 22.2866ZM19.5802 21.7066L18.6291 22.0153V22.0153L19.5802 21.7066ZM18.5338 18.4827L17.5827 18.7913L17.5827 18.7914L18.5338 18.4827ZM21 11.4003H22V9.76601L20.5448 10.5099L21 11.4003ZM13.5997 3H4V5H13.5997V3ZM4 3C1.79086 3 0 4.79086 0 7H2C2 5.89543 2.89543 5 4 5V3ZM0 7V15.3784H2V7H0ZM0 15.3784C0 17.5875 1.79086 19.3784 4 19.3784V17.3784C2.89543 17.3784 2 16.4829 2 15.3784H0ZM4 19.3784H12.4717V17.3784H4V19.3784ZM12.4717 19.3784C12.3049 19.3784 12.1415 19.3321 11.9995 19.2446L13.0487 17.5419C12.8752 17.435 12.6755 17.3784 12.4717 17.3784V19.3784ZM11.9995 19.2446L18.3177 23.138L19.3669 21.4353L13.0487 17.5419L11.9995 19.2446ZM18.3177 23.138C19.5058 23.8701 20.9622 22.7253 20.5314 21.3979L18.6291 22.0153C18.4854 21.5728 18.9709 21.1912 19.3669 21.4353L18.3177 23.138ZM20.5314 21.3979L19.485 18.1739L17.5827 18.7914L18.6291 22.0153L20.5314 21.3979ZM19.485 18.174C19.678 18.7685 19.2348 19.3784 18.6096 19.3784V17.3784C17.8763 17.3784 17.3563 18.0938 17.5827 18.7913L19.485 18.174ZM18.6096 19.3784C20.4821 19.3784 22 17.8605 22 15.988H20C20 16.7559 19.3775 17.3784 18.6096 17.3784V19.3784ZM22 15.988V11.4003H20V15.988H22ZM20.5448 10.5099C19.9324 10.823 19.2383 11 18.5 11V13C19.5621 13 20.5675 12.7445 21.4552 12.2907L20.5448 10.5099ZM18.5 11C16.0147 11 14 8.98528 14 6.5H12C12 10.0899 14.9101 13 18.5 13V11ZM14 6.5C14 5.76167 14.177 5.0676 14.4901 4.45517L12.7093 3.54483C12.2555 4.43254 12 5.43788 12 6.5H14Z"
      fill="#4A24AC"
      mask="url(#path-1-inside-1_9766_59789)"
    />
    <path
      d="M16.5 7.5H5.5C5.22386 7.5 5 7.72386 5 8C5 8.27614 5.22386 8.5 5.5 8.5H16.5C16.7761 8.5 17 8.27614 17 8C17 7.72386 16.7761 7.5 16.5 7.5Z"
      fill="#4A24AC"
    />
    <path
      d="M16.5 10.75H5.5C5.22386 10.75 5 10.9739 5 11.25C5 11.5261 5.22386 11.75 5.5 11.75H16.5C16.7761 11.75 17 11.5261 17 11.25C17 10.9739 16.7761 10.75 16.5 10.75Z"
      fill="#4A24AC"
    />
    <path
      d="M16.5 14H5.5C5.22386 14 5 14.2239 5 14.5C5 14.7761 5.22386 15 5.5 15H16.5C16.7761 15 17 14.7761 17 14.5C17 14.2239 16.7761 14 16.5 14Z"
      fill="#4A24AC"
    />
    <rect x="12.5" y="0.5" width="12" height="12" rx="6" fill="#4A24AC" />
    <rect x="12.5" y="0.5" width="12" height="12" rx="6" stroke="white" />
    <path
      d="M18.4984 3.125L19.2292 5.46244L21.6101 5.45707L19.6808 6.89631L20.4215 9.23043L18.4984 7.7825L16.5753 9.23043L17.3159 6.89631L15.3867 5.45707L17.7676 5.46244L18.4984 3.125Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
  name: "ReviewFromRbIcon"
};
</script>
